// Estado compartilhado da ligação AstraCall ativa. O AstraCallWidget (dono da
// sessão WebRTC) publica aqui o callSid/fase/mute e registra as ações; o bubble
// voice_call da timeline lê isso para mostrar os MESMOS controles (mudo/encerrar).
import { reactive } from 'vue';

const state = reactive({
  callSid: null, // = provider_call_id da chamada no AstraCall
  phase: 'idle', // idle | calling | in_call | incoming
  muted: false,
  seconds: 0, // tempo decorrido da chamada ativa (o widget publica a cada 1s)
});

let handlers = {
  toggleMute: () => {},
  hangup: () => {},
  accept: () => {},
  reject: () => {},
};

export function useAstraCall() {
  return {
    state,
    registerHandlers(h) {
      handlers = { ...handlers, ...h };
    },
    setActive(callSid, phase) {
      state.callSid = callSid;
      state.phase = phase;
    },
    setMuted(m) {
      state.muted = m;
    },
    setSeconds(s) {
      state.seconds = s;
    },
    clear() {
      state.callSid = null;
      state.phase = 'idle';
      state.muted = false;
      state.seconds = 0;
    },
    toggleMute() {
      handlers.toggleMute();
    },
    hangup() {
      handlers.hangup();
    },
    accept() {
      handlers.accept();
    },
    reject() {
      handlers.reject();
    },
  };
}
